<template>
  <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="400px" persistent>
    <v-card>
      <v-card-title class="text-h5">Enable Trial</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="trialExpiresAt"
          label="Trial Expiration Date"
          type="datetime-local"
          :min="minDateTime"
          hide-details
          dense
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="handleCancel" data-testid="cancel-button">Cancel</v-btn>
        <v-btn color="primary" text @click="handleStartTrial" :disabled="!trialExpiresAt" data-testid="start-trial-button">Start Trial</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, computed } from 'vue';

export default {
  name: 'EnableTrialModal',
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['update:modelValue', 'start', 'cancel'],
  setup(props, { emit }) {
    const trialExpiresAt = ref('');

    const handleCancel = () => {
      trialExpiresAt.value = '';
      emit('cancel');
    };

    const handleStartTrial = () => {
      emit('start', trialExpiresAt.value);
      trialExpiresAt.value = '';
    };

    const minDateTime = computed(() => {
      const now = new Date();
      // Adjust for local timezone for the datetime-local input
      now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
      return now.toISOString().slice(0, 16);
    });


    return {
      trialExpiresAt,
      handleCancel,
      handleStartTrial,
      minDateTime
    };
  },
};
</script>
